<!--Popup Header -->
<div class="d-flex popup-head align-items-center">
 <div class="popup-title mr-auto d-flex"><span translate>lblDealerWiseCheckInDetails</span> &nbsp; - &nbsp; <span translate>{{ checkInUsageReportStatus}}</span></div>
  <div class="float-right">
    <a class="close mr-2" (click)="OnClose()" translate>
      <span aria-hidden="true">&times;</span>
    </a>
  </div>
</div>

<!-- Body Header-->
<div class="subheader with-padding flgrow">
  <div class="row align-items-center">
    <!-- Multiselect Dealer Dropdown -->
    <div class="col-lg-6 col-md-6 col-sm-6">
      <div class="input-group">
        <input
        class="form-control"
        type="text"
        [(ngModel)]="dealerName"
        disabled
      />
      </div>
    </div>

    <!-- Date Range Picker -->
    <div class="col-lg-3 col-md-3 col-sm-6">
      <div class="date">
        <input
          class="form-control"
          type="text"
          [(ngModel)]="selectedDate"
          disabled
        />
      </div>
    </div>
    <a class="ml-3 btn btn-outline-primary" href="javascript:void(0);" (click)="onRefreshClick()"
    aria-label="Center Align">
    <em class="fas fa-sync fa-lg"></em>
    </a>
    <div class="pl-2  align-items-center flex-sm-row flex-column justify-content-end ml-auto" >
      <!-- Excel -->
      <button type="button" (click)="exportAsXLSX()" 
          ngbTooltip="{{'lblExportExcel' | translate}}" placement="bottom" aria-label="Center Align" style="margin-right: 10px;">
          <img src="./../../../assets/images/excel.png" height="32" width="32" alt="" />
      </button>
      <!-- PDF -->
      <button class="btn btn-link icon-pdf" type="button" (click)="exportAsPDF()" 
          ngbTooltip="{{'lblExportPDF' | translate}}" placement="left" aria-label="Center Align">
          <em class="far fa-file fa-2x"></em>
          <span class="bdg">PDF</span>
      </button>
  </div>
  </div>
</div>

<div class="scrollbar user">
  <div class="row">
    <div class="c12">
      <div class="card">
        <!-- Body Header -->
        <div class="card-header d-flex justify-content-between mx-2" translate>
          lblAppointmentDetails
          <div class="font16 fontbold">
            <span class="font16 fontnormal" translate>lblTotal</span>:&nbsp;
            {{ totalCount }}
            &nbsp;<span class="font16 fontnormal" translate>lblResults</span>
          </div>
        </div>

        <!-- Body Content -->
        <div class="table-responsive max-h357" infinite-scroll [infiniteScrollDistance]="scrollDistance"
        [infiniteScrollThrottle]="throttle" [alwaysCallback]="true" [scrollWindow]="false" (scrolled)="loadMoreData($event)">
          <table class="tablest1">
            <thead>
              <tr>
                <th style="width: 55px" scope="col">#</th>
                <th scope="col" translate>lblRegNumber</th>
                <th scope="col" translate>lblCustomer</th>
                <th scope="col" translate>lblWoNo</th>
                <th scope="col" translate>lblCheckInDate</th>
                <th scope="col" translate>lblBookedDate</th>
                <th scope="col" translate>lblCustomerMobile</th>
                <th *ngIf="showSmsFailureColumns" scope="col" translate>lblSMSFailureReason</th>
                <th *ngIf="showSmsFailureColumns" scope="col" translate>lblSMSQueueStatus</th>
                <th *ngIf="showCheckInDateTime" scope="col" translate>lblCheckInDate</th>
                <th *ngIf="showSmsSentDateTime" scope="col" translate>lblSMSSentDateTime</th>
                <th scope="col" style="width: 10%" translate>
                  lblVirtualCheckin
                </th>
                <th scope="col" style="width: 10%" translate>lblCheckinTraversalLog</th>
              </tr>
            </thead>

            <tbody>
              <ng-container
                *ngIf="
                  checkInDealerList?.length > 0;
                  else load_NotFound_Template
                "
              >
                <tr *ngFor="let item of checkInDealerList; let i = index">
                  <td>{{ i + 1 }}</td>
                  <td>
                    <div class="flmid">
                        <div class="licplate LPNo d-flex">
                            <span class="icn-flag" [ngClass]="licensePlateClass"></span>
                            {{item.licensePlate}}
                        </div>
                        <div class="imgWid">
                            <ng-container *ngIf="item.brandCode">
                                <img af-brand-logo [data-code]="item.brandCode" data-type="BRAND"
                                    class="{{item.brandCode}}-icon common"
                                    [title]="item.brandCode" class="brandicon" alt="img" />
                            </ng-container>
                        </div>
                    </div>
                    <div class="mt-1">
                        <ngb-highlight class="flmid semibold fs-12px lh-16px"
                            [result]="item.modelName">
                        </ngb-highlight>
                    </div>
                </td>
                  <td>
                    <ngb-highlight [result]="item.customerName">
                    </ngb-highlight>
                  </td>
                  <td>
                    <ngb-highlight [result]="item.workOrderNo"> </ngb-highlight>
                  </td>
                  <td>
                    <ngb-highlight [result]="item.checkInDate | date : 'short'">
                    </ngb-highlight>
                  </td>
                  <td>
                    <ngb-highlight [result]="item.bookedDate | date : 'short'">
                    </ngb-highlight>
                  </td>
                  <td>
                    <ngb-highlight [result]="item.customerMobile">
                    </ngb-highlight>
                  </td>
                  <td *ngIf="showSmsFailureColumns">
                    <ngb-highlight  [result]="item.smsFailureReason || '-'">
                    </ngb-highlight>
                  </td>
                  <td *ngIf="showSmsFailureColumns">
                    <ngb-highlight  [result]="item.smsQueueStatus">
                    </ngb-highlight>
                  </td>
                  <td *ngIf="showCheckInDateTime">
                    <ngb-highlight [result]="item.checkInDate | date : 'short'">
                    </ngb-highlight>
                  </td>
                  <td *ngIf="showSmsSentDateTime">
                    <ngb-highlight [result]="item.smsSentDateTime | date : 'short'">
                    </ngb-highlight>
                  </td>
                  <td class="text-center">
                    <em class="fas fa-check fa-lg" *ngIf="item.virtualCheckin === true"></em>
                    <em class="fas fa-times text-danger fa-lg cursordisable" *ngIf="item.virtualCheckin === false"></em>
                </td>
                <td class="text-center" >
                  <a class="btn btn-view" [ngbTooltip]="item.isCheckInStarted ? ('lblView' | translate) : (!item.isSMSSent ? ('lblSMSNotSent' | translate) : (!item.isCheckInStarted && item.isSMSSent ? ('lblSmsSentCheckInNotStarted'| translate):'')) " [ngClass]="{ 'disable': !item.isCheckInStarted }"  (click)="ViewTraversalLog(item)">
                  <em class="fa fa-route fa-lg"></em>
                </a>
                </td>
                </tr>
              </ng-container>

              <ng-template #load_NotFound_Template>
                <tr>
                  <td colspan="8" class="no-record" translate>
                    lblNoRecordsFound
                  </td>
                </tr>
              </ng-template>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Footer -->
<div class="p-3 bg-light pp-footer-top-brdr">
  <div class="row">
    <div class="col-12 d-flex flex-sm-row flex-column justify-content-end">
      <a
        (click)="OnClose()"
        type="reset"
        class="btn btn-secondary btn-lg"
        translate
        ><em class="far fa-times-circle font16 align-top mr-2"></em>lblCancel</a
      >
    </div>
  </div>
</div>
